import {
  IIntermediateTransactionInfo,
  transactionStatusType,
} from './../reducers/transactions';
import { Network } from '@kattana-io/common';
import { IIntermediateTransaction } from '../reducers/transactions';
import { ELROND_CHAIN_ID } from './getLibrary';

export const toIntermediateTransaction = (
  tx: string,
  chainId?: number,
  isTrading?: boolean
): IIntermediateTransaction => ({
  klass: chainId === ELROND_CHAIN_ID ? 'Elrond' : 'EVM',
  chain: Network.fromChainId(chainId)?.getSymbol() || 'ETH',
  trading: !!isTrading,
  description: isTrading ? 'Swap' : 'Approval',
  tx,
});

export const toIntermediateTransactionInfo = (
  status: transactionStatusType,
  time: number
): IIntermediateTransactionInfo => ({
  status,
  timeToComplete: status === 'pending' ? time + 100 : 0,
  lastUpdate: Number(new Date()),
});
